import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@gc/db-types';
import { config } from '../config';

// Singleton pattern to prevent multiple GoTrueClient instances
let _supabase: SupabaseClient<Database> | null = null;

export function getSupabaseClient(): SupabaseClient<Database> {
  if (!_supabase) {

    _supabase = createClient<Database>(config.SUPABASE_URL, config.SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
      realtime: { params: { eventsPerSecond: 5 } }
    });
  }

  return _supabase;
}